import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
export var StateManager = /*#__PURE__*/function () {
  function StateManager() {
    _classCallCheck(this, StateManager);

    _defineProperty(this, "state", void 0);

    _defineProperty(this, "notifyPromise", null);

    _defineProperty(this, "stateListeners", []);
  }

  _createClass(StateManager, [{
    key: "setInitialState",
    value: function setInitialState(defaults) {
      this.state = defaults;
    }
  }, {
    key: "get",
    value: function get() {
      if (!this.state) {
        throw new Error('[LivePerson] StateManager not initialized yet');
      }

      return this.state;
    }
  }, {
    key: "set",
    value: function set(update) {
      this.state = _Object$assign({}, this.get(), update);
      return this.notifyStateChange();
    }
  }, {
    key: "onChange",
    value: function onChange(cb) {
      var _this = this;

      this.stateListeners.push(cb);
      return function () {
        var index = _this.stateListeners.indexOf(cb);

        _this.stateListeners.splice(index, 1);
      };
    }
  }, {
    key: "notifyStateChange",
    value: function notifyStateChange() {
      var _this2 = this;

      if (this.notifyPromise) {
        return this.notifyPromise;
      }

      this.notifyPromise = new _Promise(function (resolve) {
        window.setTimeout(function () {
          _this2.stateListeners.forEach(function (cb) {
            return cb(_Object$assign({}, _this2.get()));
          });

          _this2.notifyPromise = null;
          resolve();
        }, 0);
      });
      return this.notifyPromise;
    }
  }]);

  return StateManager;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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